import { render, staticRenderFns } from "./GroupBookingCreateReceipt.vue?vue&type=template&id=ee67fc1c&scoped=true&"
import script from "./GroupBookingCreateReceipt.vue?vue&type=script&lang=js&"
export * from "./GroupBookingCreateReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee67fc1c",
  null
  
)

export default component.exports